import { render } from "./experience-colab.vue?vue&type=template&id=67ada08e"
import script from "./experience-colab.vue?vue&type=script&lang=js"
export * from "./experience-colab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__